import React from 'react';
import { Add, CallMade, Settings } from '@mui/icons-material';
import { ParticipantData } from '../../../../interface/Participant.interface';

interface ParticipantActionsProps {
    participant: ParticipantData;
    onCashIn: (participant: ParticipantData) => void;
    onWithdraw: (participant: ParticipantData) => void;
    onSettings: (participant: ParticipantData) => void;
}

export const ParticipantActions: React.FC<ParticipantActionsProps> = ({
    participant,
    onCashIn,
    onWithdraw,
    onSettings
}) => {
    return (
        <div className="actions-section">
            <button
                className="action-btn primary"
                onClick={() => onCashIn(participant)}
            >
                <Add />
                <span>Payer</span>
            </button>

            <button
                className="action-btn secondary"
                onClick={() => onWithdraw(participant)}
            >
                <CallMade />
                <span>Retrait</span>
            </button>

            <button
                className="action-btn neutral"
                onClick={() => onSettings(participant)}
            >
                <Settings />
            </button>
        </div>
    );
};
